import { render, staticRenderFns } from "./RegistrationPicker.vue?vue&type=template&id=3f44b2f7"
import script from "./RegistrationPicker.vue?vue&type=script&lang=js"
export * from "./RegistrationPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports